import i18n from '@/helpers/i18n';

export default [
  {
    _name: 'CSidebarNav',
    _children: [ 
      {
        _name: 'CSidebarNavTitle',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('coachingSessions'),
        to: '/' + i18n.t('coachingSessions') + '/' + i18n.t('list'),
        icon: 'cil-pin',
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('profile'),
        to: '/' + i18n.t('profile'),
        icon: 'cil-user'
      },
      {
        _name: 'CSidebarNavItem',
        name: i18n.t('logout'),
        to: '/logout',
        icon: 'cil-power-standby'
      },
      {
        _name: 'CSidebarNavTitle',
      }
    ]
  }
]